module.exports = __webpack_public_path__ + "static/media/c2bannerModul5_small.88fc4938.jpg";